import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
    apiKey: "AIzaSyBmUQAg6HqGTmAuybheiBocvPspWhBbL1k",
    authDomain: "nmb-performance-info.firebaseapp.com",
    projectId: "nmb-performance-info",
    storageBucket: "nmb-performance-info.firebasestorage.app",
    messagingSenderId: "844214697695",
    appId: "1:844214697695:web:896208bc7e4b49a734b36a",
    measurementId: "G-6EFWRK2TGJ"
  };

// Firebase初期化
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Firestoreインスタンスをエクスポート
export const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const functions = getFunctions(app);
export { auth, storage, functions, analytics };